import React from 'react'
import { isNumber } from 'lodash'
import { 
  Form, FormGroup, ControlLabel, FormControl,
  Modal
} from 'react-bootstrap'

import { printMoney } from '../../lib/Tools.js'

import { getText } from '../lib/text'
import Button from '../components/Button'

import { getIva, getBI } from './ReservationTools'

type PropType = {
  r: Object,
  onChange: (Object => void),
  onClose: (() => void)
}

const ReservationDetailsModal = ({ r, onChange, onClose }: PropType) => {
  const sumaBases = r.iva0 + r.iva4 + r.iva10 + r.iva21
  const sumaIvas = (r.iva4 * 0.04) + (r.iva10 * 0.1) + (r.iva21 * 0.21)

  const okStyle = { color: "black", backgroundColor: "white" }
  const errorStyle = { color: "red", backgroundColor: "#ffb3b3", fontWeight: "bold" }

  const estimated = !!(!r.baseImponible && r.finalPrice)

  return (
    <Modal show onHide={() => onClose()}>
      <Modal.Header>
        <Modal.Title>
          Detalles: {r.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>

        <Form>
          <FormGroup>
            <ControlLabel>{getText("Precio final")}</ControlLabel>
            <FormControl
              bsSize = "small"
              value={r.finalPrice}
              type="number"
              style={{ maxWidth: 200 }}
              onChange={evt => {
                // #TODO allow 0, or allow to delete the last digit
                const eur = Number.parseFloat(evt.target.value || 0) || 0
                if (isNumber(eur) && eur >= 0) {
                  onChange({ finalPrice: eur })
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <ControlLabel>{getText("Base imponible")}</ControlLabel>
            <FormControl
              bsSize = "small"
              value={
                /* Duplication: (getBI already checks r.baseImponible) because otherwise,
                 * with toFixed, the field can't be edited properly */
                r.baseImponible ? r.baseImponible : getBI(r).toFixed(2)
              }
              type="number"
              style={{ maxWidth: 200, fontStyle: estimated ? "italic" : "normal" }}
              onChange={evt => {
                // #TODO allow 0, or allow to delete the last digit
                const eur = Number.parseFloat(evt.target.value || 0) || 0
                if (isNumber(eur) && eur >= 0) {
                  onChange({ baseImponible: eur })
                }
              }}
            />
            {
              // Duplicated from the list (farther down)
              estimated && (
                <div style={{fontStyle: "italic"}}>BI estimada al {getIva(r)}%</div>
              )
            }
          </FormGroup>
        </Form>

        <Form inline style={{ marginTop: 30 }}>
          {
            [0, 4, 10, 21].map(iva => (
              <FormGroup key={`l${iva}`}>
                <ControlLabel style={{ width: 80 }}>Al {iva}%</ControlLabel>
                <FormControl
                  bsSize="small"
                  key={`f${iva}`}
                  value={r[`iva${iva}`] || 0}
                  type="number"
                  style={{ maxWidth: 130, marginRight: 20 }}
                  onChange={evt => {
                    // #TODO allow 0, or allow to delete the last digit
                    const eur = Number.parseFloat(evt.target.value || 0) || 0
                    if (isNumber(eur) && eur >= 0) {
                      onChange({ [`iva${iva}`]: eur })
                    }
                  }}
                />
                <i key={`i${iva}`}>{printMoney((iva * (r[`iva${iva}`] || 0)) / 100)}€</i>,
                <br key={`b${iva}`} />
              </FormGroup>
            ))
          }
        </Form>

        <div style={{ marginTop: 10 }}>
          <code style={{ backgroundColor: "white", color: "black" }}>
            4% * {r.iva4} + 10% * {r.iva10} + 21% * {r.iva21} = {printMoney(sumaIvas)} €
          </code>(IVA)
          <br />
          <code style={sumaBases == getBI(r).toFixed(2) ? okStyle : errorStyle}>
            {r.iva0} + {r.iva4} + {r.iva10} + {r.iva21} = {printMoney(sumaBases)} {sumaBases == getBI(r).toFixed(2) ? "=" : "≠"} {printMoney(getBI(r))} €
          </code>
          <span style={{marginLeft : 5}}>
            ({sumaBases == getBI(r).toFixed(2) ? "la base imponible es la suma de los tramos" : " la base imponible no concuerda con los tramos"})
          </span>
          <br />
          <code style={(sumaIvas + getBI(r)).toFixed(2) == r.finalPrice ? okStyle : errorStyle}>
            {printMoney(r.finalPrice)} {(sumaIvas + getBI(r)).toFixed(2) == r.finalPrice ? "=" : "≠"} {printMoney(sumaIvas + getBI(r))}
          </code>  (Total = IVA + base imponible)
        </div>

      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => onClose()}>{getText("OK")}</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReservationDetailsModal
